import { createStaticPropsGetter,Page } from "../libs/pages";

export const getStaticProps = createStaticPropsGetter(
  "politique-confidentialite"
);

export default Page;
